import { render, staticRenderFns } from "./AssetViewer.vue?vue&type=template&id=1a9a2cdd&scoped=true"
import script from "./AssetViewer.vue?vue&type=script&lang=js"
export * from "./AssetViewer.vue?vue&type=script&lang=js"
import style0 from "./AssetViewer.vue?vue&type=style&index=0&id=1a9a2cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a2cdd",
  null
  
)

export default component.exports